<script setup>
import {ref} from 'vue';
import LoadingModal from "@/components/approval-center/modals/LoadingModal.vue";
import AdvancedRevisionModal from "@/components/approval-center/modals/advanced-revision/AdvancedRevisionModal.vue";
import useApprovalFlow from "@/composables/approval-center/useApprovalFlow";
import useAdvancedRevisionFeedback from "@/composables/approval-center/advanced-revision/useAdvancedRevisionFeedback";

defineProps({
  approval: {
    type: Object,
    required: true,
  },
  loading: {
    type: Boolean,
    required: true
  },
  isError: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(['close', 'continue', 'confirm']);
const showLoadingModal = ref(false);

const {revisionErrors: errors} = useApprovalFlow();
const {fullFeedback, feedbackItems} = useAdvancedRevisionFeedback();

const handleConfirm = () => {
  showLoadingModal.value = true;
  emit('confirm');
};

const handleClose = () => {
  feedbackItems.value.clear();
  fullFeedback.value = '';
  showLoadingModal.value = false;
  emit('continue');
}
</script>

<template>
  <AdvancedRevisionModal
    :title="approval.approvable.title"
    :approvable-content="approval.approvable.content_markdown"
    :type="approval.category"
    @confirm="handleConfirm"
    @close="handleClose"
  />

  <LoadingModal
    v-if="showLoadingModal && !errors && !isError"
    :loading="loading"
    @continue="handleClose"
  />
</template>
